import React from 'react';
import { API_URL } from '../env';

const ExportMenu = ({ versionId, reportId, documentId }) => {
  const openExport = (path) => {
    window.open(`${API_URL}${path}`, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="export-menu">
      {versionId && (
        <button className="btn" onClick={() => openExport(`/api/export/docx/${versionId}`)}>
          Export Policy (.docx)
        </button>
      )}
      {reportId && (
        <>
          <button className="btn" onClick={() => openExport(`/api/export/reports/${reportId}?format=pdf`)}>
            Export Report (.pdf)
          </button>
          <button className="btn" onClick={() => openExport(`/api/export/reports/${reportId}?format=json`)}>
            Export Report (.json)
          </button>
        </>
      )}
      {documentId && (
        <>
          <button className="btn" onClick={() => openExport(`/api/export/documents/${documentId}?format=txt`)}>
            Export Document (.txt)
          </button>
          <button className="btn" onClick={() => openExport(`/api/export/documents/${documentId}?format=docx`)}>
            Export Document (.docx)
          </button>
        </>
      )}
    </div>
  );
};

export default ExportMenu;
